import {Box, BoxProps} from '@chakra-ui/react'

interface Props extends BoxProps {
  constrainedWidth?: boolean
}

export function NewResourceFormContainer({children, constrainedWidth, ...props}: Props) {
  const internalProps: BoxProps = {width: '100%', marginX: 'auto', paddingTop: {base: '4', md: '8'}, ...props}

  if (constrainedWidth) {
    internalProps.maxWidth = '48rem'
  }

  return <Box {...internalProps}>{children}</Box>
}
